import * as actions from './editor.action';
import inicialState from './editor.state';

const editorReducer = (state = inicialState, action) => {
  switch (action.type) {
    case actions.DADOS_EDITOR_RTF:
      return {
        ...state,
        textRtf: action.payload.textRtf,
      };
    case actions.DADOS_EDITOR_PLAIN_TEXT:
      return {
        ...state,
        plainText: action.payload.plainText,
      };

    case actions.ID_RTF:
      return {
        ...state,
        idRtf: action.payload.idRtf,
      };

    case actions.EDITOR_READONLY:
      return {
        ...state,
        editorReadOnly: action.payload.editorReadOnly,
      };

    case actions.CHANGE_MED_EXECUTANTE:
      return {
        ...state,
        medExecutante: action.payload.medExecutante,
      };

    case actions.CHANGE_MED_REVISOR:
      return {
        ...state,
        medRevisor: action.payload.medRevisor,
      };

    case actions.CHANGE_STATUS:
      return {
        ...state,
        status: action.payload.status,
      };

    case actions.ATUALIZAR_AVISO:
      return {
        ...state,
        mensagem: action.payload.mensagem,
        tipo: action.payload.tipo,
      };

      case actions.DADOS_EDITOR_HEADER_FOOTER:
        return {
          ...state,
          headerFooterRtf: action.payload.headerFooterRtf ,
        };

    default:
      return state;
  }
};

export default editorReducer;



// WEBPACK FOOTER //
// ./src/pages/laudo/editor/editor.reducer.js